export enum InfrastructureCategories {
  railway = 'Ж/д',
  airport = 'Аэропорт',
  seaport = 'Порт',
}

export type TInfrastructureCategoriesKeys = `${InfrastructureCategories}`;
